export default {
  suffix: 'Team',
  leaderboard: {
    title: 'Leaderboard',
  },
};
